import React from 'react';
import LegalPage from './LegalPage';
import content from '../legal/politicaDePrivacidadContent';

export default function PoliticaDePrivacidad() {
  return <LegalPage content={content} />;
}
